import { GrupoParada } from '@tivic-team/manager-ts/dist/mob/entities/parada/grupo-parada.entity';

export class GrupoParadaDTO extends GrupoParada {

    cdConcessao: number;
    cdLogradouro: number;
    cdParada: number;
    dsNmGrupoParada: String;
    dsNmGrupoParadaSuperior: String;
    dsReferencia: String;
    nmGrupoParadaSuperior: String;
    nrOrdem: String;
    nrPonto: String;
    tpConcessao: number;
    tpGrupoParadaSuperior: number;

    constructor(
        cdConcessao?:number, 
        cdLogradouro?: number, 
        cdParada?: number, 
        dsNmGrupoParada?: String,
        dsNmGrupoParadaSuperior?: String,
        dsReferencia?: String,
        nmGrupoParadaSuperior?: String,
        nrOrdem?: String,
        nrPonto?: String,
        tpConcessao?: number,
        tpGrupoParadaSuperior?: number
        ) {
        super();
        this.cdConcessao = cdConcessao;
        this.cdLogradouro = cdLogradouro;
        this.cdParada = cdParada;
        this.dsNmGrupoParada = dsNmGrupoParada;
        this.dsNmGrupoParadaSuperior = dsNmGrupoParadaSuperior;
        this.dsReferencia = dsReferencia;
        this.nmGrupoParadaSuperior = nmGrupoParadaSuperior;
        this.nrOrdem = nrOrdem;
        this.nrPonto = nrPonto;
        this.tpConcessao = tpConcessao;
        this.tpGrupoParadaSuperior = tpGrupoParadaSuperior;
        }

}

export class GrupoParadaListDTO {

    items: Array<GrupoParadaDTO>;
    total: number;

    constructor() { }

}